import { useCallback } from "react";

import { langCodeToJapanese } from "@/lib/chillnn/lang-code";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import * as Composition from "./composition";
import { HotelPolicyI18nEditMutation } from "./mutation";

import type { AccommodationHotelPolicyI18nFormModel } from "../../type";

type Props = {
	viewModel: AccommodationHotelPolicyI18nFormModel["ViewModel"];
	resetForm: () => void;
};

export const useHotelPolicyI18nEditMutation = ({ viewModel, resetForm }: Props) => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { mutationFunc } = useCustomMutation(HotelPolicyI18nEditMutation);
	/**
	 * @todo 副作用を UI で定義
	 */
	const onUpdateHotelPolicyI18n = useCallback(async () => {
		showLoadingScreenCallback();

		const { lang } = viewModel;
		const langCodeText = langCodeToJapanese(lang);
		const input = Composition.viewModelToHotelPolicyI18nInputConverter({ viewModel });
		const { errors } = await mutationFunc({
			variables: {
				hotelPolicyI18nInput: input.hotelPolicyI18nInput,
			},
		}).finally(hideLoadingScreenCallback);

		if (!errors) {
			notifyUserEventInfo({
				title: `ホテルポリシー（${langCodeText}）を更新しました`,
			});
			resetForm();
		}
	}, [hideLoadingScreenCallback, mutationFunc, resetForm, showLoadingScreenCallback, viewModel]);

	return {
		onUpdateHotelPolicyI18n,
	};
};
